export default {
      Users: 'المستخدم|المستخدمين',
      Users_no_body: 'مستخدم',

};
